module.exports = __webpack_public_path__ + "static/img/John-Bateman.4f13a84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/John-Bateman.jpg
// module id = +8VA
// module chunks = 0